import React from 'react';
import { Card } from '../components/ui/Card';

export const Settings = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-receiptWhite tracking-tight">System Configuration</h1>
        <p className="text-receiptMuted text-sm mt-1">Manage restaurant details and operational parameters.</p>
      </div>

      <Card title="General Settings">
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-mono text-receiptMuted uppercase mb-1">Restaurant Name</label>
            <input type="text" defaultValue="The Continental" className="w-full bg-chefBlack border border-chefPanel rounded p-2 text-receiptWhite focus:outline-none focus:border-chiliRed" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-mono text-receiptMuted uppercase mb-1">Target Turn Time (min)</label>
              <input type="number" defaultValue="45" className="w-full bg-chefBlack border border-chefPanel rounded p-2 text-receiptWhite focus:outline-none focus:border-chiliRed" />
            </div>
            <div>
              <label className="block text-xs font-mono text-receiptMuted uppercase mb-1">Currency</label>
              <select className="w-full bg-chefBlack border border-chefPanel rounded p-2 text-receiptWhite focus:outline-none focus:border-chiliRed">
                <option>USD ($)</option>
                <option>EUR (€)</option>
                <option>GBP (£)</option>
              </select>
            </div>
          </div>
        </div>
      </Card>

      <Card title="Integrations" className="opacity-75">
        <p className="text-receiptMuted text-sm mb-4">Connect external services (Demo Mode - Disabled)</p>
        <div className="space-y-2">
          <div className="flex justify-between items-center p-3 bg-chefBlack rounded border border-chefPanel">
            <span className="text-receiptWhite">POS System (Toast)</span>
            <span className="text-xs bg-status-open/10 text-status-open px-2 py-1 rounded">Connected</span>
          </div>
          <div className="flex justify-between items-center p-3 bg-chefBlack rounded border border-chefPanel">
            <span className="text-receiptWhite">Delivery (UberEats)</span>
            <span className="text-xs bg-chefPanel text-receiptMuted px-2 py-1 rounded">Configure</span>
          </div>
        </div>
      </Card>
    </div>
  );
};